export default "__VITE_ASSET__DsTrs8zA__"